import { render, staticRenderFns } from "./SupplierSearch.vue?vue&type=template&id=5c1927bf&"
import script from "./SupplierSearch.vue?vue&type=script&lang=js&"
export * from "./SupplierSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports